import { render, staticRenderFns } from "./CardRowComponent.vue?vue&type=template&id=70ba842a"
import script from "./CardRowComponent.vue?vue&type=script&lang=ts"
export * from "./CardRowComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports